import { Instance, Instances, useGLTF, useTexture } from '@react-three/drei';
import { useEffect, useMemo, useRef, useState } from 'react';
import * as THREE from 'three';

// Preload the roundedTable model
useGLTF.preload('/env/roundedTable.glb');

export function RoundedTable({ jsonFile, texturePath }) {
    const { nodes } = useGLTF('/env/roundedTable.glb');

    // Preload the texture
    useTexture.preload(texturePath);

    const texture = useTexture(texturePath)
    texture.colorSpace = THREE.SRGBColorSpace
    texture.flipY = false
    texture.channel = 1
    texture.generateMipmaps = false

    const material = useMemo(
        () =>
            new THREE.MeshBasicMaterial({
                toneMapped: false,
                side: THREE.DoubleSide,
                transparent: false,
                map: texture
            }),
        [texturePath]
    )

    const [data, setData] = useState([])

    useEffect(() => {
        fetch(jsonFile)
            .then(response => response.json())
            .then(jsonData => {
                const parsedData = Object.values(jsonData).map((entry) => ({
                    position: mapAxes(entry.position || [0, 0, 0]),
                    scale: mapScale(entry.scale || [0, 0, 0]),
                    rotation: mapRotation(entry.rotation || [0, 0, 0]),
                }));
                setData(parsedData);
            })
            .catch(() => setData([]));  // Reset data on error
    }, [jsonFile])

    return (
        data.length > 0 && (
            <Instances
                range={data.length}
                geometry={nodes.mainTable.geometry}
                material={material}
            >
                {data.map((props, i) => (
                    <RoundedTables key={i} {...props} />
                ))}
            </Instances>
        )
    )
}

function RoundedTables({ position, scale, rotation }) {
    const ref = useRef()
    return (
        <group
            position={position}
            scale={scale}
            rotation={rotation}
        >
            <Instance ref={ref} />
        </group>
    )
}

// Function to remap Blender axes to Three.js axes
function mapAxes([x, y, z]) {
    return [x, z, -y] 
  }
  
  function mapRotation([rx, ry, rz]) {
    return [rx, rz,-ry] 
  }
  function mapScale([rx, ry, rz]) {
    return [rx, ry, rz] 
  }